<template>
  <div class="asc-report-plots-wrapper">
    <asc-surface-title
      title="ACMF PARAMETER PLOTS"
      class="asc-report-plots-wrapper--title"
    />
    <div class="asc-report-plots-wrapper--selections">
      <asc-autocomplete-selector
        class="asc-report-plots-wrapper--selections-dropdown"
        label="Group"
        :value="graphGroupSelected"
        no-array
        :items="getPlotGroups"
        :on-change="handleGroupChanged"
        :sort-items="false"
      ></asc-autocomplete-selector>
      <div class="asc-report-plots-wrapper--selections-date">
        <asc-label size="md" value="Date Range:" />
        <asc-zoom-chips
          :active-chip="dateRange"
          :chip-list="dateChips"
          :on-select-chip="handleChipSelection"
        />
      </div>
    </div>
    <asc-spinner-wrapper :loading="loadingPagePlots">
      <template v-if="!isEmpty">
        <asc-plots-viewer-wrapper
          :page-plots="pagePlots"
          mini-plot
          reports-plot
          :loading-plot-ids="loadingPlotIds"
          :chart-data="chartData"
          :internal-user="internalUser"
          :editable="editable"
          :plot-editor="plotEditor"
          :saving="saving"
          :disabled="disabled"
          :on-toggle-page-plot-visibility="onTogglePagePlotVisibility"
          :on-expand="onExpand"
          :on-add-tab-to-page-plot="onAddTabToPagePlot"
          :on-remove-tab-from-page-plot="onRemoveTabFromPagePlot"
          :on-update-tab-view-page-plot="onUpdateTabViewPagePlot"
        ></asc-plots-viewer-wrapper>
      </template>
      <asc-no-data v-if="isEmpty"></asc-no-data>
    </asc-spinner-wrapper>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'
import AscNoData from '@/components/atoms/AscNoData'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'
import AscZoomChips from '@/components/molecules/AscZoomChips'
import AscPlotsViewerWrapper from '@/components/organisms/AscPlotsViewerWrapper'
import { ZOOM_CHIPS } from '@/utilities/appConsts'

export default {
  name: 'AscReportPlotsWrapper',

  components: {
    AscPlotsViewerWrapper,
    AscAutocompleteSelector,
    AscLabel,
    AscZoomChips,
    AscSpinnerWrapper,
    AscNoData,
    AscSurfaceTitle,
  },

  props: {
    graphGroups: {
      type: Array,
      default: () => [],
    },
    graphGroupSelected: {
      type: Number,
      default: null,
    },
    dateRange: {
      type: Number,
      default: 1,
    },
    pagePlots: {
      type: Array,
      default: () => [],
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    loadingPlotIds: {
      type: Array,
      default: () => [],
    },
    internalUser: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    plotEditor: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onTogglePagePlotVisibility: {
      type: Function,
      default: () => {},
    },
    onExpand: {
      type: Function,
      default: () => {},
    },
    onAddTabToPagePlot: {
      type: Function,
      default: () => {},
    },
    onRemoveTabFromPagePlot: {
      type: Function,
      default: () => {},
    },
    onUpdateTabViewPagePlot: {
      type: Function,
      default: () => {},
    },
    loadingPagePlots: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dateChips: ZOOM_CHIPS,
    }
  },

  computed: {
    isEmpty() {
      return !this.pagePlots?.length > 0
    },
    getPlotGroups() {
      if (this.graphGroups.length) {
        return this.graphGroups.map(item => {
          return {
            text: item.graphGroupName,
            value: item.graphGroupId,
          }
        })
      }
      return []
    },
  },

  methods: {
    handleChipSelection(data) {
      this.$emit('onDateChange', data)
    },
    handleGroupChanged(id, selection = null) {
      this.$emit('graphGroupChange', selection)
    },
  },
}
</script>

<style lang="scss">
.asc-header--h3 {
  font-size: 14px !important;
  line-height: 18px !important;
  letter-spacing: 1px !important;
  font-weight: 500 !important;
}

.asc-report-plots-wrapper {
  &--title {
    margin-bottom: 20px;
  }

  &--selections {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-dropdown {
      width: 35%;
    }

    &-date {
      .asc-zoom-chips {
        background: inherit;
      }

      .asc-zoom-chip {
        flex: inherit;
        min-width: 32px;

        .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--text) {
          height: 24px !important;
          width: 35px !important;
        }

        .v-btn {
          border: 1px solid gray;
          border-radius: 0 !important;
          font-weight: 400 !important;
        }
      }
    }
  }

  @media only screen and (max-width: 900px) {
    &--selections {
      display: block;

      &-dropdown {
        width: 100%;
        margin-bottom: 20px;
      }
    }

    & .asc-page-plots-wrapper--mini {
      display: block;

      & .asc-page-plot-wrapper--mini {
        width: 100%;
      }
    }
  }
}
</style>
